'use client'

import { cx } from 'classix'

import { type AccordionProps } from './Accordion.types'
import { Element } from './Element/Element'

import styles from './Accordion.module.scss'

export const Accordion = ({
	data,
	id,
	filled,
	secondary,
	hasBorderBottom = true,
	shouldRenderOnExpand = false,
}: AccordionProps): React.ReactNode => (
	<div
		className={cx(
			styles.accordion,
			filled && styles.filled,
			hasBorderBottom && styles.hasBorderBottom,
			secondary && styles.secondary
		)}
	>
		{data
			.filter((item) => !item.hide)
			.map(
				(
					{
						title,
						content,
						subtitle,
						onClick,
						dataTestId,
						showExpanded,
						shouldScroll,
						onExpanded,
						onCollapsed,
					},
					index
				) => {
					const elementId = `${id}-${index}`
					return (
						<Element
							title={title}
							onExpanded={onExpanded}
							onCollapsed={onCollapsed}
							subtitle={subtitle}
							dataTestId={dataTestId}
							onClick={onClick}
							id={elementId}
							key={elementId}
							showExpanded={showExpanded}
							shouldScroll={shouldScroll}
							filled={filled}
							secondary={secondary}
							shouldRenderOnExpand={shouldRenderOnExpand}
						>
							{content}
						</Element>
					)
				}
			)}
	</div>
)
